import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { ProductState, getSpecialProducts } from '@app/selectors/shoppingmall/product.selector';
import { Store } from '@ngrx/store';
import { PaginationInstance } from 'ngx-pagination';
import { Observable } from 'rxjs';

@Component({
  selector: 'hp-product',
  templateUrl: './hp-product.component.html',
  styleUrls: ['./hp-product.component.css']
})
export class HpProductComponent implements OnInit {
  @Input() urlWownet : string = "";

  products$ = new Observable<OrdPdtModel[]>();
  products: OrdPdtModel[] = [];

  config: PaginationInstance = {
    id: "main-products",
    itemsPerPage: 8,
    currentPage: 0,
    totalItems: 8,
  }
  
  constructor(
    private _productStore: Store<ProductState>) { 
    this.products$ = this._productStore.select(getSpecialProducts);
  }

  ngOnInit(): void {
    this.products$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.products = res.filter(x=> x.newYN === 'Y');
      }       
    });
  }
}
